export const rewards = {
    "entitled_first_month_50_off_campaign": "דירה זאת זכאית להטבת 50 ש״ח בתשלום החודשי!",
    "entitled_first_month_30_off_campaign": "מזל טוב. דירה זאת זכאית להטבת 30 ש״ח!"
};
